import AskQuestionModal from './AskQuestionModal.jsx';
import EscalateModal from './EscalateModal.jsx';

/**
 * Renders the shared Ask / Escalate modals, driven by useEventActions() state.
 * Rendered once per page (inbox + detail) alongside the list or detail content.
 */
function EventActionModals({ askTarget, escalateTarget, onCloseAsk, onCloseEscalate }) {
  return (
    <>
      <AskQuestionModal isOpen={Boolean(askTarget)} event={askTarget} onClose={onCloseAsk} />
      <EscalateModal isOpen={Boolean(escalateTarget)} event={escalateTarget} onClose={onCloseEscalate} />
    </>
  );
}

export default EventActionModals;
